// src/components/common/LangSwitcher.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LangSwitcher() {
  const { i18n } = useTranslation();
  const cur = i18n.language?.startsWith('zh') ? 'zh' : 'en';
  const toggle = () => i18n.changeLanguage(cur === 'en' ? 'zh' : 'en');

  return (
    <div className="lang-switch">
      {/* <span className="lang-label">{cur === 'en' ? 'English' : '中文'}</span> */}
      <button type="button" className="lang-btn" onClick={toggle}>
        {cur === 'en' ? '中文' : 'English'}
      </button>
    </div>
  );
}